import * as React from "react";
import { makeStyles } from "@material-ui/core";
import classnames from "classnames";

// material-ui and styles
import { Button } from "@material-ui/core";
import { greys, colors, helpers } from "@styles/color.styles";
import { darken } from "@clockwise/client-commons/src/util/color";
import { CWIDProps } from "@util/cw-id.util";

export interface RedButtonProps {
  onClick: () => void;
  className?: string;
  label: string;
  disabled?: boolean;
}

const useStyles = makeStyles({
  container: {},
  bold: {
    fontWeight: "bold",
  },
  button: {
    background: colors.red.standard,
    "&:hover": {
      background: helpers.opacity(colors.red.standard, 0.8),
    },
  },
  buttonRippleRoot: { color: darken(colors.red.standard, 0.1) },
  buttonLabel: { color: greys.white },
});

export const RedButton = ({
  onClick,
  className,
  label,
  disabled,
  "cw-id": cwId,
}: RedButtonProps & CWIDProps) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Button
        variant="contained"
        cw-id={cwId}
        disabled={disabled}
        onClick={onClick}
        className={classnames([classes.button, className])}
        TouchRippleProps={{
          classes: { ripple: classes.buttonRippleRoot },
        }}
      >
        <span className={classes.buttonLabel}>{label}</span>
      </Button>
    </div>
  );
};
